import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
// import { UtilityService } from 'src/app/services/utility.service';
import { Router } from '@angular/router';
import { UtilityService } from 'src/app/shared/utils/utility.service';

@Component({
  selector: 'app-exercise-header',
  templateUrl: './exercise-header.component.html',
  styleUrls: ['./exercise-header.component.css']
})
export class ExerciseHeaderComponent implements OnInit, AfterViewInit {

  @Input() headerData: any;
  showBack: boolean = false;
  courseUrl;
  constructor(private utilityService: UtilityService, private router: Router) { }

  ngOnInit() {
    this.courseUrl = this.headerData.courseTitle;
  }


  ngAfterViewInit() {
    this.utilityService.showbackButton$.subscribe(res => {
      this.showBack = res;
    });
  }

  back() {
    this.utilityService.destroyResultComponent = true;
  }

  goToCourse(title) {
    this.router.navigate(['/courses/' + title.trim().split(' ').join('-').toLowerCase()]);
  }

}
